// TODO FIX Typescript inference
export default class Singleton<T> {
  private static instance: T;

  public static get(GenericService: T = this): T {
    if (!this.instance) {
      this.instance = new GenericService();
    }

    return this.instance;
  }
}
